// extracted by mini-css-extract-plugin
export var gaugeContainer = "RadialGauge-module--gaugeContainer--1Mgta";
export var gaugeContainerMove = "RadialGauge-module--gaugeContainerMove--37YUA";
export var gaugeSetter = "RadialGauge-module--gaugeSetter--RvlO0";
export var icon = "RadialGauge-module--icon--q2kIf";
export var text = "RadialGauge-module--text--2nz7k";
export var textLabel = "RadialGauge-module--textLabel--134zj";
export var textValue = "RadialGauge-module--textValue--3sNik";
export var topRelCompensation = "RadialGauge-module--topRelCompensation--2er-p";